<template>
    <v-dialog :model-value="modelValue" persistent max-width="338">
        <v-card>
            <v-card-text class="pa-10">
                <p class="text-center">
                    <v-icon size="36"> mdi-alert-outline </v-icon>
                </p>
                <p class="body-1 font-weight-bold text-center">
                    {{ dialogText }}
                </p>
                <v-row align="center">
                    <v-col>
                        <v-btn color="primary" large block class="text-none mb-4" data-id="confirmation-button" @click="handleClick()">
                            {{ buttonText }}
                        </v-btn>
                        <v-btn large block class="text-none" data-id="back-button" @click="backToDepartures()">
                            Tilbake til avganger
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script lang="ts" setup>
defineProps<{
    modelValue: boolean;
    dialogText: string;
    buttonText: string;
}>();

const emit = defineEmits(['input', 'back-to-departures']);

const handleClick = () => {
    emit('input', false);
};

const backToDepartures = () => {
    emit('back-to-departures');
};
</script>
